import useActivities from "./useActivities";
import ActivityList from "./ActivityList";
import Activity from "./Activity";

export default function ManageActivities(){
    // Single hook instance for the whole tab; rows receive callbacks as props
    // so each row does not open its own Firestore listener.
    const { activities, createActivity, updateActivity, markActivityDeleted, restoreActivity } = useActivities()

    return(
        <>
            <Activity 
                isAddition 
                activity={{title: '', description: ''}} 
                createActivity={createActivity}
            />
            {activities && 
                <ActivityList 
                    activities={activities} 
                    updateActivity={updateActivity}
                    markActivityDeleted={markActivityDeleted}
                    restoreActivity={restoreActivity}
                />
            }
        </>
    )
}
